// ============================================================
// FloraIQ — Módulo Partes Envolvidas (Parties) · Dados Mockados
// ============================================================

export interface Party {
  id: string;
  name: string;
  type: string;
  documentId: string;
  email: string;
  phone: string;
  address: string;
  municipality: string;
  uf: string;
  institution: string;
  primaryRole: string;
  status: string;
  activeLinks: number;
  hasDocuments: boolean;
  registrationNumber?: string;
  council?: string;
  specialty?: string;
  registrationDate: string;
  lastUpdate: string;
}

export const partyTypes = [
  "Pessoa física",
  "Pessoa jurídica",
  "Órgão público",
  "Secretaria municipal",
  "Órgão ambiental",
  "Empresa executora",
  "Consultoria ambiental",
  "Condomínio",
  "Loteadora",
  "Associação/comunidade",
  "Unidade interna",
  "Outro",
];

export const partyRoles = [
  "Contratante",
  "Gestor do projeto",
  "Responsável técnico",
  "Técnico de campo",
  "Analista GIS",
  "Fiscal ambiental",
  "Órgão licenciador",
  "Órgão gestor",
  "Proprietário/possuidor",
  "Executor de manejo",
  "Executor de poda",
  "Executor de supressão",
  "Executor de replantio",
  "Responsável por compensação",
  "Validador técnico",
  "Emissor de documento",
  "Interessado externo",
  "Consulta pública",
];

export const partyStatus = [
  "Ativa",
  "Em revisão",
  "Pendente de documentação",
  "Inativa",
  "Bloqueada",
  "Arquivada",
];

export const councils = ["CREA", "CAU", "CRBio", "CRQ", "Outro", "Não informado"];

export const specialties = [
  "Engenharia Florestal",
  "Engenharia Ambiental",
  "Agronomia",
  "Biologia",
  "Arquitetura e Urbanismo",
  "Ecologia",
  "Geoprocessamento",
  "Direito Ambiental",
  "Engenharia Civil",
  "Gestão Ambiental",
];

export const orgTypes = [
  "Prefeitura",
  "Secretaria Municipal de Meio Ambiente",
  "Secretaria de Obras",
  "Defesa Civil",
  "Ministério Público",
  "Órgão ambiental estadual",
  "Unidade gestora de UC",
  "Procuradoria",
  "Agência reguladora",
  "Outro",
];

export const companyTypes = [
  "Consultoria ambiental",
  "Empresa executora",
  "Loteadora",
  "Condomínio",
  "Empresa contratante",
  "Prestadora de serviço",
  "Empresa com compensação ambiental",
  "Outra",
];

export const linkStatus = ["Ativo", "Pendente", "Em revisão", "Encerrado", "Suspenso", "Substituído"];

export interface PartyLink {
  id: string;
  partyId: string;
  partyName: string;
  role: string;
  projectId: string;
  projectName: string;
  environmentalUnitId: string;
  environmentalUnitName: string;
  environmentalUnitType: string;
  sourceDocumentId: string;
  sourceDocumentName: string;
  startDate: string;
  endDate: string;
  status: string;
  responsibility: string;
}

export interface Institution {
  id: string;
  name: string;
  type: string;
  municipality: string;
  uf: string;
  contactPerson: string;
  email: string;
  phone: string;
  linkedProjects: number;
  issuedDocuments: number;
  status: string;
}

export interface Company {
  id: string;
  companyName: string;
  tradeName: string;
  cnpj: string;
  type: string;
  contactPerson: string;
  email: string;
  phone: string;
  municipality: string;
  uf: string;
  linkedProjects: number;
  environmentalObligations: number;
  compensations: number;
  status: string;
}

export interface Report {
  id: string;
  title: string;
  description: string;
  lastGenerated: string;
  status: string;
}

export interface QualityMetric {
  label: string;
  value: string;
  percentage: number;
  icon: string;
  status: string;
}

// ====================== Parties (30+) ======================
export const parties: Party[] = [
  {
    id: "PRT-001", name: "Carlos Eduardo Mendes", type: "Pessoa física", documentId: "123.456.789-00",
    email: "carlos.mendes@floraiq.eco", phone: "(62) 99991-2345", address: "Rua T-30, 450", municipality: "Goiânia", uf: "GO",
    institution: "FloraIQ Engenharia Ambiental", primaryRole: "Responsável técnico", status: "Ativa",
    activeLinks: 8, hasDocuments: true, registrationNumber: "GO-123456-D", council: "CREA",
    specialty: "Engenharia Florestal", registrationDate: "2024-03-15", lastUpdate: "2026-06-30",
  },
  {
    id: "PRT-002", name: "Ana Paula Oliveira", type: "Pessoa física", documentId: "234.567.890-11",
    email: "ana.oliveira@floraiq.eco", phone: "(62) 99992-3456", address: "Rua T-5, 320", municipality: "Goiânia", uf: "GO",
    institution: "FloraIQ Engenharia Ambiental", primaryRole: "Técnico de campo", status: "Ativa",
    activeLinks: 5, hasDocuments: true, registrationNumber: "GO-234567-B", council: "CRBio",
    specialty: "Biologia", registrationDate: "2024-06-20", lastUpdate: "2026-06-28",
  },
  {
    id: "PRT-003", name: "Rafael Gonçalves Torres", type: "Pessoa física", documentId: "345.678.901-22",
    email: "rafael.torres@floraiq.eco", phone: "(62) 99993-4567", address: "Alameda Ricardo Paranhos, 780", municipality: "Goiânia", uf: "GO",
    institution: "FloraIQ Engenharia Ambiental", primaryRole: "Analista GIS", status: "Ativa",
    activeLinks: 4, hasDocuments: true, registrationNumber: "GO-345678-C", council: "CREA",
    specialty: "Geoprocessamento", registrationDate: "2025-01-10", lastUpdate: "2026-06-29",
  },
  {
    id: "PRT-004", name: "Juliana Souza Costa", type: "Pessoa física", documentId: "456.789.012-33",
    email: "juliana.costa@floraiq.eco", phone: "(62) 99994-5678", address: "Rua 15, 1120", municipality: "Goiânia", uf: "GO",
    institution: "FloraIQ Engenharia Ambiental", primaryRole: "Fiscal ambiental", status: "Ativa",
    activeLinks: 6, hasDocuments: true, registrationNumber: "GO-456789-F", council: "CREA",
    specialty: "Engenharia Ambiental", registrationDate: "2024-09-05", lastUpdate: "2026-06-27",
  },
  {
    id: "PRT-005", name: "Marcos Vinicius Almeida", type: "Pessoa física", documentId: "567.890.123-44",
    email: "marcos.almeida@consultoria.eco", phone: "(62) 99995-6789", address: "Av. T-63, 890", municipality: "Goiânia", uf: "GO",
    institution: "EcoGestão Consultoria", primaryRole: "Responsável técnico", status: "Ativa",
    activeLinks: 3, hasDocuments: true, registrationNumber: "GO-567890-D", council: "CREA",
    specialty: "Engenharia Florestal", registrationDate: "2023-08-12", lastUpdate: "2026-06-25",
  },
  {
    id: "PRT-006", name: "Pedro Henrique Alves", type: "Pessoa física", documentId: "678.901.234-55",
    email: "pedro.alves@floraiq.eco", phone: "(62) 99996-7890", address: "Rua C-245, 560", municipality: "Goiânia", uf: "GO",
    institution: "FloraIQ Engenharia Ambiental", primaryRole: "Técnico de campo", status: "Ativa",
    activeLinks: 4, hasDocuments: true, registrationNumber: "GO-678901-B", council: "CRBio",
    specialty: "Ecologia", registrationDate: "2025-03-01", lastUpdate: "2026-06-26",
  },
  {
    id: "PRT-007", name: "Fernanda Cristina Lima", type: "Pessoa física", documentId: "789.012.345-66",
    email: "fernanda.lima@floraiq.eco", phone: "(62) 99997-8901", address: "Rua 90, 1450", municipality: "Goiânia", uf: "GO",
    institution: "FloraIQ Engenharia Ambiental", primaryRole: "Analista GIS", status: "Ativa",
    activeLinks: 5, hasDocuments: true, registrationNumber: "GO-789012-C", council: "CREA",
    specialty: "Geoprocessamento", registrationDate: "2024-11-20", lastUpdate: "2026-06-30",
  },
  {
    id: "PRT-008", name: "Gabriel dos Santos Silva", type: "Pessoa física", documentId: "890.123.456-77",
    email: "gabriel.santos@consultoria.eco", phone: "(62) 99998-9012", address: "Rua 24, 340", municipality: "Goiânia", uf: "GO",
    institution: "EcoGestão Consultoria", primaryRole: "Consultor externo", status: "Ativa",
    activeLinks: 2, hasDocuments: false, registrationNumber: "GO-890123-D", council: "CREA",
    specialty: "Engenharia Ambiental", registrationDate: "2023-05-18", lastUpdate: "2026-06-15",
  },
  {
    id: "PRT-009", name: "Prefeitura Municipal de Goiânia", type: "Prefeitura", documentId: "01.234.567/0001-89",
    email: "gabinete@goiania.go.gov.br", phone: "(62) 3524-1000", address: "Av. do Cerrado, 999", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Contratante", status: "Ativa",
    activeLinks: 12, hasDocuments: true, registrationDate: "2022-01-10", lastUpdate: "2026-06-30",
  },
  {
    id: "PRT-010", name: "Secretaria Municipal de Meio Ambiente — AMMA", type: "Secretaria municipal", documentId: "02.345.678/0001-90",
    email: "amma@goiania.go.gov.br", phone: "(62) 3524-2000", address: "Rua 75, 150", municipality: "Goiânia", uf: "GO",
    institution: "Prefeitura Municipal de Goiânia", primaryRole: "Órgão gestor", status: "Ativa",
    activeLinks: 10, hasDocuments: true, registrationDate: "2022-03-20", lastUpdate: "2026-06-29",
  },
  {
    id: "PRT-011", name: "Secretaria Municipal de Obras", type: "Secretaria de Obras", documentId: "03.456.789/0001-01",
    email: "obras@goiania.go.gov.br", phone: "(62) 3524-3000", address: "Av. T-1, 200", municipality: "Goiânia", uf: "GO",
    institution: "Prefeitura Municipal de Goiânia", primaryRole: "Contratante", status: "Em revisão",
    activeLinks: 3, hasDocuments: true, registrationDate: "2023-05-10", lastUpdate: "2026-05-20",
  },
  {
    id: "PRT-012", name: "IBAMA — Superintendência em Goiás", type: "Órgão ambiental", documentId: "04.567.890/0001-12",
    email: "supes.go@ibama.gov.br", phone: "(62) 3222-4000", address: "Rua 229, 95", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Órgão licenciador", status: "Ativa",
    activeLinks: 6, hasDocuments: true, registrationDate: "2021-08-15", lastUpdate: "2026-06-20",
  },
  {
    id: "PRT-013", name: "Secretaria de Meio Ambiente — Estado de Goiás", type: "Órgão ambiental estadual", documentId: "05.678.901/0001-23",
    email: "semad@goias.gov.br", phone: "(62) 3201-5000", address: "Rua 82, 400", municipality: "Goiânia", uf: "GO",
    institution: "Governo do Estado de Goiás", primaryRole: "Órgão licenciador", status: "Ativa",
    activeLinks: 5, hasDocuments: true, registrationDate: "2021-12-01", lastUpdate: "2026-06-10",
  },
  {
    id: "PRT-014", name: "Ministério Público de Goiás — Promotoria do Meio Ambiente", type: "Ministério Público", documentId: "06.789.012/0001-34",
    email: "mpambiental@mpgo.mp.br", phone: "(62) 3243-6000", address: "Rua 23, 78", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Fiscal ambiental", status: "Ativa",
    activeLinks: 2, hasDocuments: true, registrationDate: "2020-06-10", lastUpdate: "2026-04-15",
  },
  {
    id: "PRT-015", name: "Francisco Nobre Barros", type: "Pessoa física", documentId: "901.234.567-88",
    email: "francisco.barros@semad.go.gov.br", phone: "(62) 3201-5001", address: "Rua T-8, 220", municipality: "Goiânia", uf: "GO",
    institution: "SEMAD-GO", primaryRole: "Validador técnico", status: "Ativa",
    activeLinks: 3, hasDocuments: true, registrationNumber: "GO-901234-D", council: "CREA",
    specialty: "Engenharia Ambiental", registrationDate: "2020-02-20", lastUpdate: "2026-06-01",
  },
  {
    id: "PRT-016", name: "Construtora Vale Verde Ltda", type: "Loteadora", documentId: "12.345.678/0001-45",
    email: "contato@valeverde.com.br", phone: "(62) 3090-8000", address: "Av. T-4, 1500", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Contratante", status: "Ativa",
    activeLinks: 4, hasDocuments: true, registrationDate: "2023-10-05", lastUpdate: "2026-06-28",
  },
  {
    id: "PRT-017", name: "Incorporadora Sul Verde S.A.", type: "Pessoa jurídica", documentId: "23.456.789/0001-56",
    email: "juridico@sulverde.com.br", phone: "(62) 3234-9000", address: "Rua 5, 890", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Responsável por compensação", status: "Ativa",
    activeLinks: 3, hasDocuments: true, registrationDate: "2024-01-25", lastUpdate: "2026-06-25",
  },
  {
    id: "PRT-018", name: "Universidade Federal de Goiás — UFG", type: "Órgão público", documentId: "34.567.890/0001-67",
    email: "reitoria@ufg.br", phone: "(62) 3521-1000", address: "Av. Universitária, 1488", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Contratante", status: "Ativa",
    activeLinks: 3, hasDocuments: true, registrationDate: "2023-02-14", lastUpdate: "2026-06-22",
  },
  {
    id: "PRT-019", name: "ICMBio — Coordenação Regional", type: "Órgão ambiental", documentId: "45.678.901/0001-78",
    email: "cr.go@icmbio.gov.br", phone: "(62) 3501-7000", address: "Rua 83, 330", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Órgão gestor", status: "Ativa",
    activeLinks: 4, hasDocuments: true, registrationDate: "2021-11-08", lastUpdate: "2026-06-18",
  },
  {
    id: "PRT-020", name: "TerraVerde Consultoria Ambiental Ltda", type: "Consultoria ambiental", documentId: "56.789.012/0001-89",
    email: "contato@terraverde.eco.br", phone: "(62) 3210-6000", address: "Alameda das Rosas, 520", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Executor de manejo", status: "Ativa",
    activeLinks: 5, hasDocuments: true, registrationDate: "2023-06-30", lastUpdate: "2026-06-29",
  },
  {
    id: "PRT-021", name: "Lúcia Helena Campos", type: "Pessoa física", documentId: "012.345.678-99",
    email: "lucia.campos@terraverde.eco.br", phone: "(62) 99999-0001", address: "Rua 12, 300", municipality: "Goiânia", uf: "GO",
    institution: "TerraVerde Consultoria Ambiental", primaryRole: "Executor de poda", status: "Ativa",
    activeLinks: 3, hasDocuments: true, registrationNumber: "GO-012345-E", council: "CREA",
    specialty: "Engenharia Florestal", registrationDate: "2023-07-15", lastUpdate: "2026-06-28",
  },
  {
    id: "PRT-022", name: "EcoGestão Consultoria e Projetos Ltda", type: "Consultoria ambiental", documentId: "67.890.123/0001-90",
    email: "projetos@ecogestao.com.br", phone: "(62) 3322-5000", address: "Av. T-63, 1450", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Validador técnico", status: "Ativa",
    activeLinks: 4, hasDocuments: true, registrationDate: "2022-09-12", lastUpdate: "2026-06-30",
  },
  {
    id: "PRT-023", name: "Defesa Civil — Goiânia", type: "Defesa Civil", documentId: "78.901.234/0001-01",
    email: "defesacivil@goiania.go.gov.br", phone: "(62) 3524-5000", address: "Av. Anhanguera, 2500", municipality: "Goiânia", uf: "GO",
    institution: "Prefeitura Municipal de Goiânia", primaryRole: "Órgão gestor", status: "Ativa",
    activeLinks: 2, hasDocuments: true, registrationDate: "2022-05-10", lastUpdate: "2026-06-15",
  },
  {
    id: "PRT-024", name: "Procuradoria Geral do Município", type: "Procuradoria", documentId: "89.012.345/0001-12",
    email: "pgm@goiania.go.gov.br", phone: "(62) 3524-6000", address: "Av. do Cerrado, 999", municipality: "Goiânia", uf: "GO",
    institution: "Prefeitura Municipal de Goiânia", primaryRole: "Órgão licenciador", status: "Ativa",
    activeLinks: 1, hasDocuments: true, registrationDate: "2022-01-15", lastUpdate: "2026-05-20",
  },
  {
    id: "PRT-025", name: "Condomínio Bueno Vista", type: "Condomínio", documentId: "90.123.456/0001-23",
    email: "sindico@buenovista.com.br", phone: "(62) 3099-1000", address: "Rua T-36, 780", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Proprietário/possuidor", status: "Ativa",
    activeLinks: 2, hasDocuments: true, registrationDate: "2024-04-01", lastUpdate: "2026-06-20",
  },
  {
    id: "PRT-026", name: "Associação de Moradores do Setor Universitário", type: "Associação/comunidade", documentId: "01.987.654/0001-34",
    email: "contato@amoruni.org.br", phone: "(62) 3999-2000", address: "Praça Universitária, s/n", municipality: "Goiânia", uf: "GO",
    institution: "—", primaryRole: "Interessado externo", status: "Ativa",
    activeLinks: 1, hasDocuments: false, registrationDate: "2024-08-10", lastUpdate: "2026-06-01",
  },
  {
    id: "PRT-027", name: "Roberta Nunes Vieira", type: "Pessoa física", documentId: "111.222.333-44",
    email: "roberta.vieira@pm.go.gov.br", phone: "(62) 99991-1111", address: "Rua 14, 450", municipality: "Goiânia", uf: "GO",
    institution: "Prefeitura Municipal de Goiânia", primaryRole: "Técnico de campo", status: "Pendente de documentação",
    activeLinks: 1, hasDocuments: false, registrationDate: "2026-05-20", lastUpdate: "2026-06-10",
  },
  {
    id: "PRT-028", name: "Ricardo José Pereira", type: "Pessoa física", documentId: "222.333.444-55",
    email: "ricardo.pereira@prestadora.eco", phone: "(62) 99992-2222", address: "Rua 99, 120", municipality: "Goiânia", uf: "GO",
    institution: "Prestadora Ambiental Ltda", primaryRole: "Executor de supressão", status: "Inativa",
    activeLinks: 0, hasDocuments: false, registrationDate: "2025-08-15", lastUpdate: "2026-03-10",
  },
  {
    id: "PRT-029", name: "Maria do Carmo Silva", type: "Pessoa física", documentId: "333.444.555-66",
    email: "maria.silva@agencia.org.br", phone: "(62) 99993-3333", address: "Rua 8, 670", municipality: "Goiânia", uf: "GO",
    institution: "Agência Reguladora Municipal", primaryRole: "Órgão licenciador", status: "Bloqueada",
    activeLinks: 0, hasDocuments: true, registrationDate: "2024-06-12", lastUpdate: "2026-02-28",
  },
  {
    id: "PRT-030", name: "Eng. Paulo Roberto Nascimento", type: "Pessoa física", documentId: "444.555.666-77",
    email: "paulo.nascimento@engenharia.eco", phone: "(62) 99994-4444", address: "Av. T-2, 1800", municipality: "Goiânia", uf: "GO",
    institution: "Nascimento Engenharia Ltda", primaryRole: "Responsável técnico", status: "Ativa",
    activeLinks: 2, hasDocuments: true, registrationNumber: "GO-444555-D", council: "CREA",
    specialty: "Engenharia Civil", registrationDate: "2023-04-25", lastUpdate: "2026-06-22",
  },
  {
    id: "PRT-031", name: "Patrícia Amaro Teixeira", type: "Pessoa física", documentId: "555.666.777-88",
    email: "patricia.teixeira@oab.go.gov.br", phone: "(62) 99995-5555", address: "Rua 101, 200", municipality: "Goiânia", uf: "GO",
    institution: "OAB-GO / Comissão de Direito Ambiental", primaryRole: "Interessado externo", status: "Em revisão",
    activeLinks: 1, hasDocuments: false, registrationDate: "2026-01-10", lastUpdate: "2026-06-05",
  },
  {
    id: "PRT-032", name: "Agência Municipal de Meio Ambiente — AMMA (gestão)", type: "Secretaria municipal", documentId: "02.345.678/0001-90",
    email: "gestao.amma@goiania.go.gov.br", phone: "(62) 3524-2100", address: "Rua 75, 150 — Sala 301", municipality: "Goiânia", uf: "GO",
    institution: "Prefeitura Municipal de Goiânia", primaryRole: "Gestor do projeto", status: "Ativa",
    activeLinks: 7, hasDocuments: true, registrationDate: "2022-03-20", lastUpdate: "2026-06-30",
  },
];

// ====================== Technical Responsibles ======================
export const technicalResponsibles = parties.filter(
  (p) => p.primaryRole === "Responsável técnico" && p.council && p.registrationNumber
);

// ====================== Institutions ======================
export const institutions: Institution[] = [
  {
    id: "INS-001", name: "Prefeitura Municipal de Goiânia", type: "Prefeitura",
    municipality: "Goiânia", uf: "GO", contactPerson: "Dr. Eduardo Marques", email: "gabinete@goiania.go.gov.br",
    phone: "(62) 3524-1000", linkedProjects: 8, issuedDocuments: 24, status: "Ativa",
  },
  {
    id: "INS-002", name: "Secretaria Municipal de Meio Ambiente — AMMA", type: "Secretaria Municipal de Meio Ambiente",
    municipality: "Goiânia", uf: "GO", contactPerson: "Dra. Helena Borges", email: "amma@goiania.go.gov.br",
    phone: "(62) 3524-2000", linkedProjects: 6, issuedDocuments: 18, status: "Ativa",
  },
  {
    id: "INS-003", name: "IBAMA — Superintendência Goiás", type: "Órgão ambiental estadual",
    municipality: "Goiânia", uf: "GO", contactPerson: "Dr. Miguel Arantes", email: "supes.go@ibama.gov.br",
    phone: "(62) 3222-4000", linkedProjects: 4, issuedDocuments: 12, status: "Ativa",
  },
  {
    id: "INS-004", name: "SEMAD — Secretaria de Meio Ambiente do Estado de Goiás", type: "Órgão ambiental estadual",
    municipality: "Goiânia", uf: "GO", contactPerson: "Eng. Francisco Barros", email: "semad@goias.gov.br",
    phone: "(62) 3201-5000", linkedProjects: 3, issuedDocuments: 10, status: "Ativa",
  },
  {
    id: "INS-005", name: "Ministério Público de Goiás — Promotoria Ambiental", type: "Ministério Público",
    municipality: "Goiânia", uf: "GO", contactPerson: "Dr. Renata Siqueira", email: "mpambiental@mpgo.mp.br",
    phone: "(62) 3243-6000", linkedProjects: 2, issuedDocuments: 5, status: "Ativa",
  },
  {
    id: "INS-006", name: "ICMBio — Coordenação Regional Goiás", type: "Unidade gestora de UC",
    municipality: "Goiânia", uf: "GO", contactPerson: "Biól. Daniel Ferreira", email: "cr.go@icmbio.gov.br",
    phone: "(62) 3501-7000", linkedProjects: 3, issuedDocuments: 8, status: "Ativa",
  },
  {
    id: "INS-007", name: "Defesa Civil — Goiânia", type: "Defesa Civil",
    municipality: "Goiânia", uf: "GO", contactPerson: "Cel. Roberto Lima", email: "defesacivil@goiania.go.gov.br",
    phone: "(62) 3524-5000", linkedProjects: 2, issuedDocuments: 4, status: "Ativa",
  },
  {
    id: "INS-008", name: "Procuradoria Geral do Município de Goiânia", type: "Procuradoria",
    municipality: "Goiânia", uf: "GO", contactPerson: "Dr. Antônio Cabral", email: "pgm@goiania.go.gov.br",
    phone: "(62) 3524-6000", linkedProjects: 1, issuedDocuments: 3, status: "Em revisão",
  },
];

// ====================== Companies ======================
export const companies: Company[] = [
  {
    id: "EMP-001", companyName: "Construtora Vale Verde Ltda", tradeName: "Vale Verde Empreendimentos",
    cnpj: "12.345.678/0001-45", type: "Loteadora", contactPerson: "Eng. Rodrigo Vale",
    email: "contato@valeverde.com.br", phone: "(62) 3090-8000", municipality: "Goiânia", uf: "GO",
    linkedProjects: 3, environmentalObligations: 5, compensations: 2, status: "Ativa",
  },
  {
    id: "EMP-002", companyName: "Incorporadora Sul Verde S.A.", tradeName: "Sul Verde Incorporadora",
    cnpj: "23.456.789/0001-56", type: "Empresa com compensação ambiental", contactPerson: "Dra. Carla Fontes",
    email: "juridico@sulverde.com.br", phone: "(62) 3234-9000", municipality: "Goiânia", uf: "GO",
    linkedProjects: 2, environmentalObligations: 4, compensations: 3, status: "Ativa",
  },
  {
    id: "EMP-003", companyName: "TerraVerde Consultoria Ambiental Ltda", tradeName: "TerraVerde",
    cnpj: "56.789.012/0001-89", type: "Consultoria ambiental", contactPerson: "Eng. Lúcia Campos",
    email: "contato@terraverde.eco.br", phone: "(62) 3210-6000", municipality: "Goiânia", uf: "GO",
    linkedProjects: 4, environmentalObligations: 0, compensations: 0, status: "Ativa",
  },
  {
    id: "EMP-004", companyName: "EcoGestão Consultoria e Projetos Ltda", tradeName: "EcoGestão",
    cnpj: "67.890.123/0001-90", type: "Consultoria ambiental", contactPerson: "Eng. Marcos Almeida",
    email: "projetos@ecogestao.com.br", phone: "(62) 3322-5000", municipality: "Goiânia", uf: "GO",
    linkedProjects: 3, environmentalObligations: 0, compensations: 0, status: "Ativa",
  },
  {
    id: "EMP-005", companyName: "Nascimento Engenharia e Meio Ambiente Ltda", tradeName: "NEMA",
    cnpj: "98.765.432/0001-10", type: "Empresa executora", contactPerson: "Eng. Paulo Nascimento",
    email: "contato@nema.eco.br", phone: "(62) 3344-7000", municipality: "Goiânia", uf: "GO",
    linkedProjects: 2, environmentalObligations: 1, compensations: 1, status: "Ativa",
  },
  {
    id: "EMP-006", companyName: "Condomínio Bueno Vista", tradeName: "Bueno Vista",
    cnpj: "90.123.456/0001-23", type: "Condomínio", contactPerson: "Síndico Mário Rocha",
    email: "sindico@buenovista.com.br", phone: "(62) 3099-1000", municipality: "Goiânia", uf: "GO",
    linkedProjects: 1, environmentalObligations: 3, compensations: 0, status: "Ativa",
  },
  {
    id: "EMP-007", companyName: "Prestadora Ambiental Ltda", tradeName: "EcoServiços",
    cnpj: "11.222.333/0001-44", type: "Prestadora de serviço", contactPerson: "Ricardo Pereira",
    email: "contato@ecoservicos.com.br", phone: "(62) 3091-3000", municipality: "Goiânia", uf: "GO",
    linkedProjects: 2, environmentalObligations: 2, compensations: 0, status: "Em revisão",
  },
  {
    id: "EMP-008", companyName: "TechFlora Geotecnologia Ltda", tradeName: "TechFlora",
    cnpj: "22.333.444/0001-55", type: "Prestadora de serviço", contactPerson: "Eng. Felipe Dantas",
    email: "contato@techflora.com.br", phone: "(62) 3400-5000", municipality: "Goiânia", uf: "GO",
    linkedProjects: 1, environmentalObligations: 0, compensations: 0, status: "Ativa",
  },
];

// ====================== Party Links (20+) ======================
export const partyLinks: PartyLink[] = [
  { id: "LNK-001", partyId: "PRT-001", partyName: "Carlos Eduardo Mendes", role: "Responsável técnico", projectId: "PRJ-2026-005", projectName: "Implantação do CTA — Goiânia Centro", environmentalUnitId: "—", environmentalUnitName: "—", environmentalUnitType: "—", sourceDocumentId: "DOC-001", sourceDocumentName: "ART CREA-GO 123456", startDate: "2026-04-10", endDate: "2026-12-15", status: "Ativo", responsibility: "Coordenação técnica do inventário e emissão de relatórios técnicos" },
  { id: "LNK-002", partyId: "PRT-002", partyName: "Ana Paula Oliveira", role: "Técnico de campo", projectId: "PRJ-2026-005", projectName: "Implantação do CTA — Goiânia Centro", environmentalUnitId: "—", environmentalUnitName: "—", environmentalUnitType: "—", sourceDocumentId: "DOC-002", sourceDocumentName: "Ordem de Serviço 2026/045", startDate: "2026-04-10", endDate: "2026-12-15", status: "Ativo", responsibility: "Cadastro dendrométrico e vistoria de árvores urbanas" },
  { id: "LNK-003", partyId: "PRT-009", partyName: "Prefeitura Municipal de Goiânia", role: "Contratante", projectId: "PRJ-2026-005", projectName: "Implantação do CTA — Goiânia Centro", environmentalUnitId: "—", environmentalUnitName: "—", environmentalUnitType: "—", sourceDocumentId: "DOC-003", sourceDocumentName: "Contrato Adm. 2026/0001", startDate: "2026-03-01", endDate: "2026-12-31", status: "Ativo", responsibility: "Contratante e financiador do projeto" },
  { id: "LNK-004", partyId: "PRT-010", partyName: "Secretaria Municipal de Meio Ambiente — AMMA", role: "Órgão gestor", projectId: "PRJ-2026-005", projectName: "Implantação do CTA — Goiânia Centro", environmentalUnitId: "—", environmentalUnitName: "—", environmentalUnitType: "—", sourceDocumentId: "DOC-004", sourceDocumentName: "Portaria AMMA 2026/0089", startDate: "2026-04-01", endDate: "2026-12-31", status: "Ativo", responsibility: "Acompanhamento e homologação dos resultados" },
  { id: "LNK-005", partyId: "PRT-001", partyName: "Carlos Eduardo Mendes", role: "Responsável técnico", projectId: "PRJ-2026-008", projectName: "Parque Municipal Ambiental Norte", environmentalUnitId: "UC-001", environmentalUnitName: "Parque Municipal Ambiental Norte", environmentalUnitType: "Parque", sourceDocumentId: "DOC-005", sourceDocumentName: "ART CREA-GO 123457", startDate: "2026-02-20", endDate: "2026-07-15", status: "Ativo", responsibility: "Responsável técnico pelo inventário florístico do parque" },
  { id: "LNK-006", partyId: "PRT-016", partyName: "Construtora Vale Verde Ltda", role: "Contratante", projectId: "PRJ-2026-007", projectName: "Loteamento Verde Vale", environmentalUnitId: "—", environmentalUnitName: "—", environmentalUnitType: "—", sourceDocumentId: "DOC-006", sourceDocumentName: "Contrato Empresarial 2026/015", startDate: "2026-05-01", endDate: "2026-08-30", status: "Ativo", responsibility: "Contratante e responsável pela compensação ambiental" },
  { id: "LNK-007", partyId: "PRT-017", partyName: "Incorporadora Sul Verde S.A.", role: "Responsável por compensação", projectId: "PRJ-2026-011", projectName: "Compensação Ambiental — Corredor Verde Sul", environmentalUnitId: "CV-001", environmentalUnitName: "Corredor Verde Sul", environmentalUnitType: "Corredor verde", sourceDocumentId: "DOC-007", sourceDocumentName: "TCA 2025/0032", startDate: "2025-09-01", endDate: "2026-05-30", status: "Encerrado", responsibility: "Execução e monitoramento da compensação ambiental" },
  { id: "LNK-008", partyId: "PRT-020", partyName: "TerraVerde Consultoria Ambiental Ltda", role: "Executor de manejo", projectId: "PRJ-2026-008", projectName: "Parque Municipal Ambiental Norte", environmentalUnitId: "UC-001", environmentalUnitName: "Parque Municipal Ambiental Norte", environmentalUnitType: "Parque", sourceDocumentId: "DOC-008", sourceDocumentName: "Contrato de Prestação 2026/022", startDate: "2026-03-01", endDate: "2026-12-31", status: "Ativo", responsibility: "Execução de manejo arbóreo emergencial nas árvores de risco" },
  { id: "LNK-009", partyId: "PRT-012", partyName: "IBAMA — Superintendência em Goiás", role: "Órgão licenciador", projectId: "PRJ-2026-010", projectName: "Inventário de UC — Parque Natural Municipal", environmentalUnitId: "UC-002", environmentalUnitName: "Parque Natural Municipal", environmentalUnitType: "UC", sourceDocumentId: "DOC-009", sourceDocumentName: "Autorização 2026/IBAMA-0123", startDate: "2026-06-01", endDate: "2027-06-01", status: "Pendente", responsibility: "Autorização para pesquisa e inventário dentro da UC" },
  { id: "LNK-010", partyId: "PRT-025", partyName: "Condomínio Bueno Vista", role: "Proprietário/possuidor", projectId: "PRJ-2026-009", projectName: "Monitoramento de Árvores Críticas — Setor Bueno", environmentalUnitId: "—", environmentalUnitName: "—", environmentalUnitType: "—", sourceDocumentId: "DOC-010", sourceDocumentName: "Contrato Condominial 2026/001", startDate: "2026-03-10", endDate: "2026-09-10", status: "Ativo", responsibility: "Responsável pela manutenção das árvores em áreas comuns" },
  { id: "LNK-011", partyId: "PRT-004", partyName: "Juliana Souza Costa", role: "Validador técnico", projectId: "PRJ-2026-005", projectName: "Implantação do CTA — Goiânia Centro", environmentalUnitId: "—", environmentalUnitName: "—", environmentalUnitType: "—", sourceDocumentId: "DOC-011", sourceDocumentName: "ART CREA-GO 123458", startDate: "2026-04-10", endDate: "2026-12-15", status: "Ativo", responsibility: "Validação técnica dos dados de campo e laudos fitossanitários" },
  { id: "LNK-012", partyId: "PRT-018", partyName: "Universidade Federal de Goiás — UFG", role: "Contratante", projectId: "PRJ-2026-006", projectName: "Inventário Arbóreo — Praça Universitária", environmentalUnitId: "PV-003", environmentalUnitName: "Praça Universitária", environmentalUnitType: "Praça", sourceDocumentId: "DOC-012", sourceDocumentName: "Convênio UFG-FloraIQ 2026", startDate: "2026-01-15", endDate: "2026-03-30", status: "Encerrado", responsibility: "Contratante e gestor da área inventariada" },
  { id: "LNK-013", partyId: "PRT-010", partyName: "Secretaria Municipal de Meio Ambiente — AMMA", role: "Gestor do projeto", projectId: "PRJ-2026-012", projectName: "Projeto Carbono Urbano — Áreas Verdes Municipais", environmentalUnitId: "AV-001", environmentalUnitName: "Áreas Verdes Municipais", environmentalUnitType: "Área verde", sourceDocumentId: "DOC-013", sourceDocumentName: "Portaria AMMA 2026/0145", startDate: "2026-01-05", endDate: "2026-06-30", status: "Ativo", responsibility: "Gestão do projeto de carbono e coordenação das equipes" },
  { id: "LNK-014", partyId: "PRT-022", partyName: "EcoGestão Consultoria e Projetos Ltda", role: "Validador técnico", projectId: "PRJ-2026-012", projectName: "Projeto Carbono Urbano — Áreas Verdes Municipais", environmentalUnitId: "AV-001", environmentalUnitName: "Áreas Verdes Municipais", environmentalUnitType: "Área verde", sourceDocumentId: "DOC-014", sourceDocumentName: "Contrato Validação 2026/033", startDate: "2026-03-01", endDate: "2026-07-30", status: "Ativo", responsibility: "Validação independente das estimativas de carbono" },
  { id: "LNK-015", partyId: "PRT-013", partyName: "Secretaria de Meio Ambiente — Estado de Goiás", role: "Órgão licenciador", projectId: "PRJ-2026-007", projectName: "Loteamento Verde Vale", environmentalUnitId: "—", environmentalUnitName: "—", environmentalUnitType: "—", sourceDocumentId: "DOC-015", sourceDocumentName: "Licença Ambiental 2026/GO-0456", startDate: "2026-05-01", endDate: "2028-05-01", status: "Ativo", responsibility: "Licenciamento ambiental do loteamento" },
  { id: "LNK-016", partyId: "PRT-019", partyName: "ICMBio — Coordenação Regional", role: "Órgão gestor", projectId: "PRJ-2026-010", projectName: "Inventário de UC — Parque Natural Municipal", environmentalUnitId: "UC-002", environmentalUnitName: "Parque Natural Municipal", environmentalUnitType: "UC", sourceDocumentId: "DOC-016", sourceDocumentName: "Plano de Manejo 2024", startDate: "2024-01-01", endDate: "2030-01-01", status: "Ativo", responsibility: "Gestão da Unidade de Conservação" },
  { id: "LNK-017", partyId: "PRT-014", partyName: "Ministério Público de Goiás — Promotoria do Meio Ambiente", role: "Fiscal ambiental", projectId: "PRJ-2026-008", projectName: "Parque Municipal Ambiental Norte", environmentalUnitId: "UC-001", environmentalUnitName: "Parque Municipal Ambiental Norte", environmentalUnitType: "Parque", sourceDocumentId: "DOC-017", sourceDocumentName: "TAC 2025/0008", startDate: "2025-11-15", endDate: "2027-11-15", status: "Ativo", responsibility: "Fiscalização do cumprimento do TAC ambiental" },
  { id: "LNK-018", partyId: "PRT-006", partyName: "Pedro Henrique Alves", role: "Executor de poda", projectId: "PRJ-2026-008", projectName: "Parque Municipal Ambiental Norte", environmentalUnitId: "UC-001", environmentalUnitName: "Parque Municipal Ambiental Norte", environmentalUnitType: "Parque", sourceDocumentId: "DOC-018", sourceDocumentName: "Ordem de Serviço 2026/078", startDate: "2026-05-01", endDate: "2026-12-31", status: "Ativo", responsibility: "Execução de podas corretivas e de segurança" },
  { id: "LNK-019", partyId: "PRT-021", partyName: "Lúcia Helena Campos", role: "Executor de replantio", projectId: "PRJ-2026-011", projectName: "Compensação Ambiental — Corredor Verde Sul", environmentalUnitId: "CV-001", environmentalUnitName: "Corredor Verde Sul", environmentalUnitType: "Corredor verde", sourceDocumentId: "DOC-019", sourceDocumentName: "Relatório de Plantio 2026/01", startDate: "2025-10-01", endDate: "2026-06-30", status: "Encerrado", responsibility: "Plantio compensatório de 2.150 mudas nativas" },
  { id: "LNK-020", partyId: "PRT-005", partyName: "Marcos Vinicius Almeida", role: "Responsável técnico", projectId: "PRJ-2026-011", projectName: "Compensação Ambiental — Corredor Verde Sul", environmentalUnitId: "CV-001", environmentalUnitName: "Corredor Verde Sul", environmentalUnitType: "Corredor verde", sourceDocumentId: "DOC-020", sourceDocumentName: "ART CREA-GO 234567", startDate: "2025-09-01", endDate: "2026-05-30", status: "Encerrado", responsibility: "Supervisão técnica da compensação ambiental" },
];

// ====================== Reports ======================
export const partyReports: Report[] = [
  { id: "RPT-001", title: "Relatório de partes por projeto", description: "Listagem consolidada de todas as partes envolvidas agrupadas por projeto, com papéis e responsabilidades.", lastGenerated: "2026-06-30", status: "disponivel" },
  { id: "RPT-002", title: "Relatório de responsáveis técnicos", description: "Relação completa de responsáveis técnicos com registros profissionais, projetos vinculados e documentos emitidos.", lastGenerated: "2026-06-28", status: "disponivel" },
  { id: "RPT-003", title: "Relatório de órgãos e instituições", description: "Cadastro de órgãos públicos e instituições com contatos, projetos e documentos emitidos.", lastGenerated: "2026-06-25", status: "disponivel" },
  { id: "RPT-004", title: "Relatório de empresas executoras", description: "Empresas, consultorias e prestadoras de serviço com projetos, obrigações e compensações.", lastGenerated: "2026-06-22", status: "disponivel" },
  { id: "RPT-005", title: "Relatório de vínculos ambientais", description: "Mapeamento de vínculos entre partes e unidades ambientais (árvores, áreas verdes, UCs, compensações).", lastGenerated: "2026-06-20", status: "gerando" },
  { id: "RPT-006", title: "Relatório de obrigações por parte", description: "Consolidado de responsabilidades, restrições e autorizações atribuídas a cada parte envolvida.", lastGenerated: "2026-06-18", status: "disponivel" },
  { id: "RPT-007", title: "Relatório de partes sem documento", description: "Partes cadastradas que ainda não possuem documentação comprobatória anexada ao sistema.", lastGenerated: "2026-06-15", status: "pendente" },
  { id: "RPT-008", title: "Relatório de governança LADM-FloraIQ", description: "Visão integrada do modelo Party-Source-SpatialUnit-RRR com todos os vínculos e relacionamentos.", lastGenerated: "—", status: "pendente" },
];

// ====================== Quality Metrics ======================
export const partyQualityMetrics: QualityMetric[] = [
  { label: "Partes com contato completo", value: "87.4%", percentage: 87.4, icon: "ri-contacts-book-line", status: "good" },
  { label: "Partes com documento", value: "72.1%", percentage: 72.1, icon: "ri-file-list-line", status: "good" },
  { label: "Partes com vínculo ativo", value: "73.8%", percentage: 73.8, icon: "ri-link-m", status: "good" },
  { label: "Responsáveis técnicos com registro", value: "93.4%", percentage: 93.4, icon: "ri-medal-line", status: "good" },
  { label: "Vínculos com documento fonte", value: "78.5%", percentage: 78.5, icon: "ri-file-text-line", status: "good" },
  { label: "Partes sem papel definido", value: "12.6%", percentage: 12.6, icon: "ri-question-line", status: "warning" },
  { label: "Vínculos pendentes", value: "15.2%", percentage: 15.2, icon: "ri-time-line", status: "warning" },
  { label: "Documentos vencidos por parte", value: "4.8%", percentage: 4.8, icon: "ri-error-warning-line", status: "danger" },
];

// ====================== Summary ======================
export const partiesSummary = {
  total: parties.length,
  technicalResponsibles: technicalResponsibles.length,
  publicOrgs: parties.filter((p) => p.type.includes("Órgão") || p.type.includes("Prefeitura") || p.type.includes("Secretaria") || p.type === "Defesa Civil" || p.type === "Ministério Público" || p.type === "Procuradoria").length,
  companies: parties.filter((p) => p.type === "Pessoa jurídica" || p.type === "Loteadora" || p.type === "Consultoria ambiental" || p.type === "Condomínio" || p.type === "Empresa executora").length,
  withActiveLinks: parties.filter((p) => p.activeLinks > 0).length,
  pendingLinks: partyLinks.filter((l) => l.status === "Pendente").length,
  withoutDocs: parties.filter((p) => !p.hasDocuments).length,
  totalObligations: partyLinks.length,
};